module.exports = __webpack_public_path__ + "static/img/about_12.f87e664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_12.png
// module id = r36j
// module chunks = 1